import React, { ReactNode } from 'react'
import { styled } from 'src/ui/theme'
import { useDimensions } from 'src/ui/dimensions'

const Wrapper = styled.a<{ isMobile?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'row' : 'column')};
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: ${({ isMobile }) => (isMobile ? 'nowrap' : 'wrap')};
  gap: 46px;
  padding: 32px 40px;
  background-color: #f3f3f3;
  min-width: 244px;
  text-decoration: none;
  cursor: pointer;
`

const TextField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #010000;
`

const Subtitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  color: #010000;
`

const Description = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0px;
  color: #010000;
`

const IconBlock = styled.div`
  width: 48px;
  height: 48px;
`

type TProps = {
  icon: ReactNode
  title: string
  subtitle: string
  description: string
  link: string
  className?: string
  expandable?: boolean
}

export const AchievementCard = ({
  description,
  icon,
  subtitle,
  title,
  link,
  className,
}: TProps) => {
  const { isMobile } = useDimensions()
  return (
    <Wrapper
      className={className}
      isMobile={isMobile}
      href={link}
      target="_blank"
    >
      <IconBlock>{icon}</IconBlock>
      <TextField>
        <TitleBlock>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TitleBlock>

        <Description>{description}</Description>
      </TextField>
    </Wrapper>
  )
}
